import { ItemModel } from '@syncfusion/ej2-angular-navigations';

export const FEEDBACK_FORM = 'https://forms.office.com/e/Xadt2ervr7';
export const USER_MANUAL = 'https://documentation.cigp.app/books/e-platform-admin';
export const FA_REPORTS_BASE_URL = 'https://fa-reports.cigp.app';

export const CIGP_COLORS = [
  '#56725A',
  '#5A7865',
  '#5F7E71',
  '#63837D',
  '#678789',
  '#6C858E',
  '#708294',
  '#757F99',
  '#797B9F',
  '#847EA5',
  '#9282AA',
  '#A086B0',
  '#AE8BB5',
  '#BB8FB8',
  '#C094B3',
  '#C698AE',
  '#CB9DA9',
  '#D1A1A3',
  '#D6AFA6',
  '#DCBFAB',
  '#E1CFAF'
];

export const ROLE_AUDIT_TRAIL_IB_PRIVATE_OPPORTUNITIES_DISTRIBUTION_READ =
  'AuditTrailIbPrivateOpportunitiesDistribution.Read';
export const ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ = 'AuditTrailMonthlyStatementsDistribution.Read';
export const ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_READ = 'AuditTrailTransactionNotesDistribution.Read';
export const ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_SEND_NOTIFICATION =
  'AuditTrailTransactionNotesDistribution.SendNotification';
export const ROLE_AUDIT_TRAIL_USER_ACTIONS_READ = 'AuditTrailUserActions.Read';
export const ROLE_COMPLIANCE = 'Compliance';
export const ROLE_TDRATES_WRITE = 'TdRates.Write';

export const CACHE_DURATION_HOURS = 4;

export const STORE_ACCOUNTS = 'accounts';
export const STORE_STAFFS = 'staffs';
export const STORE_USERS = 'users';

export const ID_PREFIX_CIGP = 'cigp-';

export const ID_EDIT_MAPPINGS = 'editMappings';
export const TOOLBAR_ITEM_MAPPINGS: ItemModel = {
  text: 'Mappings',
  tooltipText: 'Edit Mappings',
  prefixIcon: 'e-transform',
  id: ID_EDIT_MAPPINGS,
  disabled: true
};

export const ID_GO_TO_MESSAGES = 'goToMessages';
export const TOOLBAR_ITEM_MESSAGES: ItemModel = {
  text: 'Messages',
  tooltipText: 'Messages',
  prefixIcon: 'e-rename',
  id: ID_GO_TO_MESSAGES,
  disabled: true
};

export const ID_GO_TO_DOCUMENTS = 'goToDocuments';
export const TOOLBAR_ITEM_DOCUMENTS: ItemModel = {
  text: 'Documents',
  tooltipText: 'Documents',
  prefixIcon: 'e-folder-open',
  id: ID_GO_TO_DOCUMENTS,
  disabled: true
};

export const ID_SEND_EMAIL = 'sendEmail';
export const TOOLBAR_ITEM_SEND_EMAIL: ItemModel = {
  text: 'Send Email',
  tooltipText: 'Send by email',
  prefixIcon: 'e-send',
  id: ID_SEND_EMAIL,
  disabled: true
};

export const ID_RESET_2FA = 'reset2fa';
export const TOOLBAR_ITEM_RESET_2FA: ItemModel = {
  text: 'Reset 2FA',
  tooltipText: 'Reset 2FA device registrations',
  prefixIcon: 'e-double-check',
  id: ID_RESET_2FA,
  disabled: true
};

export const ID_RESET_PASSWORD = 'resetPassword';
export const TOOLBAR_ITEM_RESET_PASSWORD: ItemModel = {
  text: 'Reset Password',
  tooltipText: 'Reset user password',
  prefixIcon: 'e-reset',
  id: ID_RESET_PASSWORD,
  disabled: true
};

export const ID_ACTIVATE_ACCOUNT = 'activateAccount';
export const TOOLBAR_ITEM_ACTIVATE_ACCOUNT: ItemModel = {
  text: 'Activate',
  tooltipText: 'Activate user account',
  prefixIcon: 'e-unlock',
  id: ID_ACTIVATE_ACCOUNT,
  disabled: true
};

export const ID_DEACTIVATE_ACCOUNT = 'deactivateAccount';
export const TOOLBAR_ITEM_DEACTIVATE_ACCOUNT: ItemModel = {
  text: 'Deactivate',
  tooltipText: 'Deactivate user account',
  prefixIcon: 'e-unlock',
  id: ID_DEACTIVATE_ACCOUNT,
  disabled: true
};

export const ID_TOGGLE_INACTIVE_USERS = 'toggleInactiveUsers';
export const TOOLBAR_ITEM_TOGGLE_INACTIVE_USERS: ItemModel = {
  text: 'Show Inactive',
  tooltipText: 'Toggle inactive users visibility',
  prefixIcon: 'e-hide',
  id: ID_TOGGLE_INACTIVE_USERS,
  disabled: false
};

export const ID_VALIDATE_MAPPING = 'validateMapping';
export const TOOLBAR_ITEM_VALIDATE_MAPPING: ItemModel = {
  text: 'Validate Mapping',
  tooltipText: 'Validate mapping',
  prefixIcon: 'e-changes-accept',
  id: ID_VALIDATE_MAPPING,
  disabled: true
};

export const ID_REJECT_MAPPING = 'rejectMapping';
export const TOOLBAR_ITEM_REJECT_MAPPING: ItemModel = {
  text: 'Reject Mapping',
  tooltipText: 'Reject mapping',
  prefixIcon: 'e-changes-reject',
  id: ID_REJECT_MAPPING,
  disabled: true
};

export const ID_GENERATE_TRANSACTION_NOTE = 'generateTransactionNote';
export const TOOLBAR_ITEM_GENERATE_TRANSACTION_NOTE: ItemModel = {
  text: 'Generate and Distribute Note',
  tooltipText: 'Generate and distribute transaction confirmation note',
  prefixIcon: 'e-file-new',
  id: ID_GENERATE_TRANSACTION_NOTE,
  disabled: true
};

export const USER_TYPE_CLIENT = 'client';
export const USER_TYPE_STAFF = 'staff';

export const TD_RATES_CURRENCIES = ['USD', 'EUR', 'HKD', 'CNH', 'GBP', 'CHF', 'AUD', 'NZD', 'CAD'];
